var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { BindingEngine } from "aurelia-binding";
import { Router } from "aurelia-router";
import { I18N } from 'aurelia-i18n';
import { UnitOfWorkObserver } from "../../../../../utilities/unit-of-work-observer";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../constants/authentication/claims";
import { ValidationsClientService } from "../../../../../services/validations/validations-client.service";
import { EntityTypes } from "../../../../../models/basics/basics.models";
import { EnumUtilities } from "../../../../../utilities/enum-utilities";
import * as Enumerable from 'linq';
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { BindingSignaler } from "aurelia-templating-resources";
import { Reflection } from "../../../../../utilities/reflection";
import { PermissionEntity } from "../../../../../models/manage/permissions.models";
var ManageValidations = /** @class */ (function () {
    function ManageValidations(validationsClientService, engine, notificationClientService, router, bindingSignaler, userClaimsService, i18N) {
        this.validationsClientService = validationsClientService;
        this.engine = engine;
        this.notificationClientService = notificationClientService;
        this.router = router;
        this.bindingSignaler = bindingSignaler;
        this.userClaimsService = userClaimsService;
        this.i18N = i18N;
        this.validations = [];
        this.primitivePropertyValidationsPerType = {};
        this.collectionPropertyValidationsPerType = {};
        this.twoLevelPropertyValidationsPerType = {};
        this.collectionProperties = {};
        this.oneLevelValidationsPerType = {};
        this.canUpdateValidations = true;
        this.canAddValidations = true;
        this.canDeleteValidations = true;
        this.validationTypes = [];
        this.selectedEntityNavigationMapper = null;
        this.loading = true;
        this.canUpdateValidations = this.userClaimsService.hasPermission(Claims.CanUpdatePermissions);
    }
    ManageValidations.prototype.activate = function (params) {
        params.type = Number(params.type);
        this.typeId = params.type;
        this.id = params.id;
        this.entityName = params.name;
        if (this.typeId === PermissionEntity.Branch) {
            this.entityTypeDisplayName = this.i18N.tr('branch-text');
        }
        else if (this.typeId === PermissionEntity.Department) {
            this.entityTypeDisplayName = this.i18N.tr('department-text');
        }
        else if (this.typeId === PermissionEntity.Role) {
            this.entityTypeDisplayName = this.i18N.tr('role-text');
        }
        else if (this.typeId === PermissionEntity.User) {
            this.entityTypeDisplayName = this.i18N.tr('user-text');
        }
        this.getAllValidations();
    };
    ManageValidations.prototype.getAllValidations = function () {
        var _this = this;
        if (this.validationsUow) {
            this.validationsUow.dispose();
        }
        setTimeout(function () {
            _this.validationsClientService.getValidationRulesForLevel({ validationEntity: _this.typeId, entityId: _this.id }).then(function (x) {
                _this.validations = x.validationRules;
                _this.entityNavigationMappers = x.entityTrees;
                _this.validationTypes = x.validationTypes;
                _this.tablesMetadata = x.tablesMetadata;
                _this.entityTypeRelations = x.entityTypeRelations;
                _this.tablesColumnsMetadata = Enumerable.from(x.tablesMetadata).selectMany(function (x) { return x.tableColumnMetadatas; }).toArray();
                _this.entityNavigationMappers.forEach(function (mapper) {
                    if (!_this.primitivePropertyValidationsPerType[mapper.rootEntityType]) {
                        _this.primitivePropertyValidationsPerType[mapper.rootEntityType] = [];
                    }
                    if (!_this.oneLevelValidationsPerType[mapper.rootEntityType]) {
                        _this.oneLevelValidationsPerType[mapper.rootEntityType] = [];
                    }
                    if (!_this.twoLevelPropertyValidationsPerType[mapper.rootEntityType]) {
                        _this.twoLevelPropertyValidationsPerType[mapper.rootEntityType] = [];
                    }
                    if (!_this.collectionPropertyValidationsPerType[mapper.rootEntityType]) {
                        _this.collectionPropertyValidationsPerType[mapper.rootEntityType] = [];
                    }
                });
                _this.validations.forEach(function (validation) {
                    if (!validation.childEntityType && _this.primitivePropertyValidationsPerType[validation.rootEntityType]) {
                        _this.primitivePropertyValidationsPerType[validation.rootEntityType].push(validation);
                    }
                    else if (validation.childEntityType && validation.tableColumnMetadataId && !validation.isCollectionTypeValidationRule) {
                        var entityMapper = _this.entityNavigationMappers.filter(function (x) { return x.rootEntityType == validation.rootEntityType; })[0];
                        if (_this.oneLevelValidationsPerType[validation.rootEntityType] && entityMapper.oneLevelNestedProperties.some(function (z) { return z.childEntityType == validation.childEntityType && _this.tablesMetadata.some(function (y) { return y.id == z.tableMetadataId && y.tableColumnMetadatas.some(function (d) { return d.id == validation.tableColumnMetadataId; }); }); }))
                            _this.oneLevelValidationsPerType[validation.rootEntityType].push(validation);
                        else if (_this.twoLevelPropertyValidationsPerType[validation.rootEntityType]) {
                            _this.twoLevelPropertyValidationsPerType[validation.rootEntityType].push(validation);
                        }
                    }
                    if (validation.isCollectionTypeValidationRule) {
                        _this.collectionPropertyValidationsPerType[validation.rootEntityType].push(validation);
                    }
                });
                _this.entityTypeRelations.forEach(function (x) {
                    if (!_this.collectionProperties[x.parentEntityType]) {
                        _this.collectionProperties[x.parentEntityType] = [];
                    }
                    _this.collectionProperties[x.parentEntityType].push(x);
                });
                _this.selectedEntityNavigationMapper = _this.entityNavigationMappers[0];
                _this.loading = false;
                setTimeout(function () {
                    _this.validationsUow = UnitOfWorkObserver.getTrackingInstance(_this.engine, { validations: _this.validations }, []);
                });
            }, function (e) { });
        });
    };
    ManageValidations.prototype.getOneLevelValidations = function (prop) {
        return this.oneLevelValidationsPerType[this.selectedEntityNavigationMapper.rootEntityType].filter(function (x) { return x.childEntityType == prop.childEntityType; });
    };
    ManageValidations.prototype.getTwoLevelValidations = function (prop) {
        var oneLevelProperties = prop.oneLevelNestedProperties;
        var tableColumnMetadataIds = Enumerable.from(this.tablesMetadata.filter(function (x) { return oneLevelProperties.some(function (y) { return y.tableMetadataId == x.id; }); })).selectMany(function (x) { return x.tableColumnMetadatas; }).toArray();
        return this.twoLevelPropertyValidationsPerType[this.selectedEntityNavigationMapper.rootEntityType].filter(function (x) { return x.childEntityType == prop.childEntityType &&
            tableColumnMetadataIds.some(function (d) { return d.id == x.tableColumnMetadataId; }); });
    };
    ManageValidations.prototype.getEntityName = function (entityType) {
        return entityType ? EnumUtilities.getName(EntityTypes, entityType) : null;
    };
    ManageValidations.prototype.getValidationTypes = function (entityType, tableColumnMetadataId) {
        var tableColumnMetadata = this.tablesColumnsMetadata.filter(function (x) { return x.id == tableColumnMetadataId; })[0];
        var response = this.validationTypes && tableColumnMetadata
            ? this.validationTypes.filter(function (x) { return (!x.supportedEntities || x.supportedEntities.length == 0 || x.supportedEntities.some(function (y) { return y == entityType; }))
                && (!x.supportedPropertyTypes || x.supportedPropertyTypes.length == 0 || x.supportedPropertyTypes.some(function (y) { return y == tableColumnMetadata.tableColumnDataTypeId; })); })
            : this.validationTypes;
        return response;
    };
    ManageValidations.prototype.goBack = function () {
        this.router.navigateBack();
    };
    ManageValidations.prototype.getSelectedOneLevelProperties = function (validationRule) {
        var res = this.selectedEntityNavigationMapper.twoLevelNestedProperties.filter(function (x) { return x.childEntityType == validationRule.childEntityType; })[0];
        return res ? res.oneLevelNestedProperties : null;
    };
    ManageValidations.prototype.getSelected = function (validationRule) {
        if (this.selectedEntityNavigationMapper.twoLevelNestedProperties) {
            var prop = this.selectedEntityNavigationMapper.twoLevelNestedProperties.filter(function (x) { return x.childEntityType == validationRule.childEntityType; })[0];
            if (!prop) {
                return null;
            }
            var oneLevelProperties = prop.oneLevelNestedProperties;
            var selectedTableColumnMetadata_1 = this.tablesColumnsMetadata.filter(function (x) { return validationRule.tableColumnMetadataId == x.id; })[0].tableMetadataId;
            var selectedTable_1 = this.tablesMetadata.filter(function (x) { return x.id == selectedTableColumnMetadata_1; })[0];
            return oneLevelProperties.filter(function (x) { return x.tableMetadataId == selectedTable_1.id; })[0];
        }
        return null;
    };
    ManageValidations.prototype.getTableColumns = function (entityNavigationMapper, validationRule, level) {
        if (level == 0) {
            var tableMetadata = this.tablesMetadata.filter(function (x) { return x.id == entityNavigationMapper.tableMetadataId; })[0];
            var arr = entityNavigationMapper && entityNavigationMapper.tableMetadataId && tableMetadata ? tableMetadata.tableColumnMetadatas : null;
            return arr && arr.length > 0 ? arr : null;
        }
        else if (level == 1) {
            var entity_1 = entityNavigationMapper.oneLevelNestedProperties.filter(function (x) { return x.childEntityType == validationRule.childEntityType; })[0];
            var arr = entity_1 ? this.tablesColumnsMetadata.filter(function (x) { return entity_1.tableMetadataId == x.tableMetadataId; }) : null;
            return arr && arr.length > 0 ? arr : null;
        }
        else if (level == 2) {
            var entity = entityNavigationMapper.twoLevelNestedProperties.filter(function (x) { return x.childEntityType == validationRule.childEntityType; })[0];
            if (entity == null) {
                return null;
            }
            var tableMetadata_1 = this.tablesColumnsMetadata.filter(function (x) { return x.id == validationRule.tableColumnMetadataId; })[0];
            if (tableMetadata_1) {
                var selectedNestedProperty_1 = entity.oneLevelNestedProperties.filter(function (x) { return x.tableMetadataId == tableMetadata_1.tableMetadataId; })[0];
                return entity && selectedNestedProperty_1 ? this.tablesColumnsMetadata.filter(function (x) { return selectedNestedProperty_1.tableMetadataId == x.tableMetadataId; }) : null;
            }
            return null;
        }
        return null;
    };
    ManageValidations.prototype.addNewPropertyValidation = function (collection, prop) {
        var newValidationRule = {
            childEntityType: prop && prop.childEntityType ? prop.childEntityType : null,
            dbId: 0,
            entityTypeRelation: null,
            entityTypeRelationId: null,
            isCollectionTypeValidationRule: false,
            rootEntityType: this.selectedEntityNavigationMapper.rootEntityType,
            tableColumnMetadata: null,
            tableColumnMetadataId: null,
            validationParam: null,
            validationType: null
        };
        collection[this.selectedEntityNavigationMapper.rootEntityType].push(newValidationRule);
        this.validations.push(newValidationRule);
        if (prop && 'oneLevelNestedProperties' in prop) {
            var tableColumnMetadataIds = Enumerable.from(this.tablesMetadata.filter(function (x) { return prop.oneLevelNestedProperties.some(function (y) { return y.tableMetadataId == x.id; }); })).selectMany(function (x) { return x.tableColumnMetadatas; }).toArray();
            newValidationRule.tableColumnMetadataId = tableColumnMetadataIds[0].id;
            this.bindingSignaler.signal('two-level-validations-' + prop.childEntityType);
        }
        else if (prop) {
            this.bindingSignaler.signal('validations-' + prop.childEntityType);
        }
    };
    ManageValidations.prototype.onOneLevelValidationRefresh = function (validationRule) {
        this.bindingSignaler.signal('validation-' + validationRule.dbId);
    };
    ManageValidations.prototype.onTwoLevelValidationRefresh = function (validationRule) {
        this.bindingSignaler.signal('two-level-validation-' + validationRule.dbId);
    };
    ManageValidations.prototype.onSelectedNestedPropertyChanged = function ($event, validationRule) {
        var _this = this;
        var item = $event.detail.item;
        if (item && item.tableMetadataId > 0) {
            var tableMetadatas = this.tablesMetadata.filter(function (x) { return item.tableMetadataId == x.id; })[0].tableColumnMetadatas;
            validationRule.tableColumnMetadataId = tableMetadatas.some(function (x) { return x.id == validationRule.tableColumnMetadataId; }) ? validationRule.tableColumnMetadataId : tableMetadatas[0].id;
            setTimeout(function () {
                _this.bindingSignaler.signal('two-level-validation-nested-prop-' + validationRule.dbId);
            });
        }
    };
    ManageValidations.prototype.removeValidation = function (validationRule, collection, prop) {
        if (collection) {
            var index = collection[this.selectedEntityNavigationMapper.rootEntityType].indexOf(validationRule);
            if (index > -1) {
                collection[this.selectedEntityNavigationMapper.rootEntityType].splice(index, 1);
            }
        }
        if (this.validations) {
            var index = this.validations.indexOf(validationRule);
            if (index > -1) {
                this.validations.splice(index, 1);
            }
        }
        if (prop && Reflection.getPropertyName(function (x) { return x.oneLevelNestedProperties; }) in prop) {
            this.bindingSignaler.signal('two-level-validations-' + prop.childEntityType);
        }
        else if (prop) {
            this.bindingSignaler.signal('validations-' + prop.childEntityType);
        }
    };
    ManageValidations.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.validationsClientService.save({ changes: _this.validationsUow.getChanges(), validationEntity: _this.typeId, entityId: _this.id }).then(function (x) {
                _this.notificationClientService.show(_this.i18N.tr('validations-saved-successfully-text'), "", NotificationType.Success);
                setTimeout(function () {
                    _this.validationsUow.dispose();
                    _this.validationsUow = UnitOfWorkObserver.getTrackingInstance(_this.engine, { validations: _this.validations }, []);
                });
                resolve();
            }).catch(function (ex) {
                _this.notificationClientService.show(_this.i18N.tr('failed-to-persist-validation-changes-text'), "", NotificationType.Error);
                reject();
            });
        });
    };
    ManageValidations = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ValidationsClientService,
            BindingEngine,
            NotificationClientService,
            Router,
            BindingSignaler,
            UserClaimsService,
            I18N])
    ], ManageValidations);
    return ManageValidations;
}());
export { ManageValidations };
